import { render, staticRenderFns } from "./EditUserInfoModal.vue?vue&type=template&id=18057bd5&scoped=true"
import script from "./EditUserInfoModal.vue?vue&type=script&lang=ts"
export * from "./EditUserInfoModal.vue?vue&type=script&lang=ts"
import style0 from "./EditUserInfoModal.vue?vue&type=style&index=0&id=18057bd5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18057bd5",
  null
  
)

export default component.exports